import React, { useState, useEffect } from 'react';
import './Comment.modules.css';
import './PinnedComment.modules.css';

const PinnedComment = ({ comment, duration }) => {
  const [isVisible, setIsVisible] = useState(false); // 表示状態を管理
  const [pinnedComment, setPinnedComment] = useState(null); // 固定表示するコメント

  useEffect(() => {
    if (pinnedComment != null) {
        setPinnedComment(null);
        setIsVisible(false);
    }

    setPinnedComment(comment);
    setIsVisible(true); // 初期表示でスライドイン

    const timeout = setTimeout(() => {
      setIsVisible(false); // 一定時間後にフェードアウト
      setPinnedComment(null); // コメントをクリア
    }, duration);

    return () => clearTimeout(timeout); // クリーンアップ
  }, [comment, duration]);

  return (
    <div className={`pinned-comment ${isVisible ? 'slide-in' : 'fade-out'}`}>
        {pinnedComment ?? comment}
    </div>
  );
};

export default PinnedComment;
